// URL pattern: match a bare http(s) URL preceded by start-of-string, whitespace,
// an opening paren or bracket. We stop at whitespace, < > " ' ) ].
const URL_RX = /(^|[\s(\[])(https?:\/\/[^\s<>"')\]]+)/g;

// Trailing punctuation that should not be part of a URL when sitting at the
// very end of a match (e.g. "see https://example.com.").
const TRAILING_PUNCT_RX = /[.,;:!?]+$/;

function autoLinkUrls(s) {
  if (typeof s !== 'string' || !s) return s;
  // If the content already contains an anchor with a href, leave it alone:
  // we would otherwise re-wrap the inner URL and create nested <a> tags.
  if (/<a\b[^>]*\bhref\s*=/i.test(s)) return s;

  return s.replace(URL_RX, (_match, prefix, url) => {
    let clean = url;
    let suffix = '';
    const trailing = url.match(TRAILING_PUNCT_RX);
    if (trailing) {
      clean = url.slice(0, -trailing[0].length);
      suffix = trailing[0];
    }
    // sanitizeHTML will re-apply rel="noopener noreferrer" and strip any
    // javascript:/data: scheme, so we don't need to escape further here.
    return `${prefix}<a href="${clean}" target="_blank" rel="noopener noreferrer">${clean}</a>${suffix}`;
  });
}

export function formatMessageContent(content) {
  const rawContent = typeof content === 'string' ? content : String(content || '');

  if (!rawContent.trim()) {
    return rawContent;
  }

  if (/<li[\s>]/i.test(rawContent)) {
    return autoLinkUrls(rawContent);
  }

  const hasNonBreakHtmlTags = /<(?!br\s*\/?\s*>)[a-z][^>]*>/i.test(rawContent);
  if (hasNonBreakHtmlTags) {
    return autoLinkUrls(rawContent);
  }

  const normalized = rawContent.replace(/<br\s*\/?>/gi, '\n');
  const hasListSyntax = /^\s*(?:[-*•]|\d+[.)])\s+.+/m.test(normalized);

  if (!hasListSyntax) {
    return autoLinkUrls(rawContent);
  }

  const lines = normalized.split('\n');
  const output = [];
  let activeList = null;

  function closeList() {
    if (activeList) {
      output.push(`</${activeList}>`);
      activeList = null;
    }
  }

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (!trimmed) {
      closeList();
      output.push('<br>');
      return;
    }

    const unorderedMatch = trimmed.match(/^[-*•]\s+(.+)$/);
    if (unorderedMatch) {
      if (activeList !== 'ul') {
        closeList();
        activeList = 'ul';
        output.push('<ul>');
      }
      output.push(`<li>${unorderedMatch[1]}</li>`);
      return;
    }

    const orderedMatch = trimmed.match(/^\d+[.)]\s+(.+)$/);
    if (orderedMatch) {
      if (activeList !== 'ol') {
        closeList();
        activeList = 'ol';
        output.push('<ol>');
      }
      output.push(`<li>${orderedMatch[1]}</li>`);
      return;
    }

    closeList();
    output.push(trimmed);
  });

  closeList();
  return autoLinkUrls(output.join(''));
}
